import * as Sentry from '@sentry/react';

// 日誌工具模組
class Logger {
  constructor() {
    this.isDebug = process.env.REACT_APP_DEBUG === 'true' || process.env.NODE_ENV === 'development';
  }

  // 格式化時間戳
  getTimestamp() {
    return new Date().toISOString();
  }

  // 格式化日誌訊息
  formatMessage(level, category, message, data = null) {
    const timestamp = this.getTimestamp();
    const baseMessage = `[${timestamp}] [${level}] [${category}] ${message}`;
    
    if (data) {
      return `${baseMessage}\n資料: ${JSON.stringify(data, null, 2)}`;
    }
    
    return baseMessage;
  }

  // 一般資訊日誌
  info(category, message, data = null) {
    if (this.isDebug) {
      console.log(this.formatMessage('INFO', category, message, data));
    }
  }

  // 警告日誌
  warn(category, message, data = null) {
    if (this.isDebug) {
      console.warn(this.formatMessage('WARN', category, message, data));
    }
  }

  // 錯誤日誌
  error(category, message, data = null) {
    console.error(this.formatMessage('ERROR', category, message, data));

    Sentry.withScope((scope) => {
      scope.setTag('category', category);
      if (data) {
        scope.setExtra('data', data);
      }
      Sentry.captureMessage(`[${category}] ${message}`, 'error');
    });
  }

  // 成功日誌
  success(category, message, data = null) {
    if (this.isDebug) {
      console.log(`✅ ${this.formatMessage('SUCCESS', category, message, data)}`);
    }
  }

  // API 請求日誌
  apiRequest(method, url, data = null) {
    if (this.isDebug) {
      console.log(`🌐 ${this.formatMessage('API_REQUEST', 'API', `${method} ${url}`, data)}`);
    }
  }

  // API 回應日誌
  apiResponse(method, url, status, data = null) {
    if (this.isDebug) {
      //const level = status >= 200 && status < 300 ? 'SUCCESS' : 'ERROR';
      console.log(`📡 ${this.formatMessage('API_RESPONSE', 'API', `${method} ${url} - ${status}`, data)}`);
    }
  }

  // 認證相關日誌
  auth(message, data = null) {
    this.info('AUTH', message, data);
  }

  // 使用者操作日誌
  userAction(action, data = null) {
    this.info('USER_ACTION', action, data);
  }

  // 狀態變更日誌
  stateChange(component, oldState, newState) {
    if (this.isDebug) {
      console.log(`🔄 ${this.formatMessage('STATE_CHANGE', component, '狀態變更', {
        old: oldState,
        new: newState
      })}`);
    }
  }
}

// 建立單例實例
const logger = new Logger();

export default logger;
